export default __webpack_public_path__ + "980d5bd06b56b75f291bc36f37ed642d.svg";